var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer d-flex align-items-center justify-content-center"},[_vm._v(" © Copyright 2021. ViSEA ATI ")])}
var staticRenderFns = []

export { render, staticRenderFns }